import { render, staticRenderFns } from "./BandejaBotonAsignarComponente.vue?vue&type=template&id=fd7682ac"
import script from "./BandejaBotonAsignarComponente.vue?vue&type=script&lang=js"
export * from "./BandejaBotonAsignarComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports